/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import React from 'react';
import { initializeApp } from './init.ts';

initializeApp()
  .then((initConfig) => {
    if (!initConfig) {
      throw new Error('AntFlow server configuration is missing');
    }
    const antflowServerConfig = {
      apiPrefix: initConfig?.antflowServerConfig?.apiPrefix || '',
      apiUrl: initConfig?.antflowServerConfig?.apiUrl || import.meta.env.BASE_URL,
      topic: initConfig?.antflowServerConfig?.topic || '',
      defaultGroup: initConfig?.antflowServerConfig?.defaultGroup || '',
      filterTags: initConfig?.antflowServerConfig?.filterTags || [],
      oidc: initConfig?.antflowServerConfig?.oidc,
      launcherSnippet: initConfig?.antflowServerConfig?.launcherSnippet
    };

    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <App
          antflowServerConfig={antflowServerConfig}
          antflowExternalServices={initConfig?.antflowExternalServices}
          themes={initConfig?.themes}
        />
      </StrictMode>
    );
  })
  .catch(() => {
    console.error('Failed to initialize app');
  });
